import classNames from 'classnames';
import React from 'react';

interface HintBarProps {
  text: string;
  className?: string;
}

export const HintBar: React.FC<HintBarProps> = ({ text, className }) => {
  if (!text) {
    return null;
  }

  return (
    <div className={classNames('flex justify-center pointer-events-none', className)}>
      <div className="bg-white dark:bg-[#242424] px-4 py-2 rounded-3xl shadow-md w-fit max-w-[50vw] text-center">
        <p className="text-sm text-black dark:text-white max-w-[40vw]">{text}</p>
      </div>
    </div>
  );
};
